import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-signature-approval-list',
  templateUrl: './signature-approval-list.component.html',
  styleUrls: ['./signature-approval-list.component.scss'],
  standalone: false,
})
export class SignatureApprovalListComponent {
  @Input() signaturePolicies: any[] = [];
  @Input() currentSignatures: any[] = [];

  getSignatureCount(policyId: string): number {
    return this.currentSignatures.filter(sig => sig.signaturePolicyId === policyId).length;
  }

  getRequiredCount(policy: any): number {
    return policy.requiredCount || 1;
  }

  isGroupComplete(policy: any): boolean {
    const current = this.getSignatureCount(policy.id);
    const required = this.getRequiredCount(policy);
    return current >= required;
  }
}
